import RequestPasswordResetForm from './RequestPasswordResetForm';

export default RequestPasswordResetForm;